/**
 * 装配体零部件拖拽事件定义。
 *
 * 说明：
 * 1. 仅负责定义事件名称枚举、载荷类型与注册列表；
 * 2. 不承载任何业务逻辑，业务逻辑由 AssemblyPartDragStrategy 负责派发，
 *    订阅方（如 AssemblyToolbarTab）负责消费。
 */

/**
 * 装配体零部件拖拽事件名称枚举。
 */
export enum AssemblyDragEventName {
    /** 装配体零部件拖拽开始。 */
    DragStarted = 'assemblyPartDragStarted',
    /** 装配体零部件拖拽停止。 */
    DragStopped = 'assemblyPartDragStopped',
}



/**
 * 装配体拖拽事件注册列表。
 */
export const assemblyDragEventNames: IEventBus.CadEventName[] = [
    AssemblyDragEventName.DragStarted,
    AssemblyDragEventName.DragStopped,
];
